import { ServerAppSettings } from '@/types';
import { MutationTree } from 'vuex';

import {
  SET_IS_SHOW_USER_SETTINGS,
  SET_SERVER_APP_SETTINGS,
  SET_IS_SHOW_CHANGE_PASSWORD,
  SET_IS_SHOW_SIGN_OUT_DIALOG,
  SET_IS_SHOW_CREDENTIALS,
} from './mutationTypes';

import { AppState } from './types';

export const mutations: MutationTree<AppState> = {
  [SET_IS_SHOW_USER_SETTINGS](state, payload: boolean) {
    state.isShowUserSettings = payload;
  },

  [SET_SERVER_APP_SETTINGS](state, settings: ServerAppSettings) {
    state.links = {
      ...settings.links,
    };
    state.isWriteBacklogAudio = settings.isWriteBacklogAudio;
    state.isWriteBacklogVideo = settings.isWriteBacklogVideo;
    state.turnServer = settings.turnServer ?? '';
    state.turnUser = settings.turnUser ?? '';
    state.turnCredential = settings.turnCredential ?? '';
    state.useTurnServer = settings.useTurnServer ?? false;
    state.testMode = settings.testMode ?? false;
    state.showSignerPrompt = settings.showSignerPrompt ?? false;
    state.showGloss = settings.showGloss ?? false;
    state.allowMessageEditing = settings.allowMessageEditing ?? false;
    state.isModelPickerEnabled = settings.isModelPickerEnabled ?? false;
    state.showInstanceId = settings.showInstanceId ?? false;
    state.instanceId = settings.instanceId ?? '';
  },

  [SET_IS_SHOW_CHANGE_PASSWORD](state, payload: boolean) {
    state.isShowChangePassword = payload;
  },

  [SET_IS_SHOW_SIGN_OUT_DIALOG](state, payload: boolean) {
    state.isShowSignOutDialog = payload;
  },

  [SET_IS_SHOW_CREDENTIALS](state, payload: boolean) {
    state.isShowCredentials = payload;
  },
};
